import { render, staticRenderFns } from "./ImportacionCodigos.vue?vue&type=template&id=4ab4b248&"
import script from "./ImportacionCodigos.vue?vue&type=script&lang=js&"
export * from "./ImportacionCodigos.vue?vue&type=script&lang=js&"
import style0 from "./ImportacionCodigos.vue?vue&type=style&index=0&id=4ab4b248&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports